export const resetData = (state) => {
    state.onwedAlbums = {
        data: {},
        currentRequestId: "",
        sortOrder:"",
        sortCriteria:"",
        loading: "",
        error: "",
    }
    state.captionSortAlbums = {
        data: {},
        individualAlphabetCache: [],
        currentRequestId: "",
        sortOrder:"",
        sortCriteria: "caption",
        loading: "",
        error: "",
    }
    state.mySharedAlbums = {
        data: {},
        error: "",
    }
    state.myFriendsAlbums = {
        data: {},
        error: "",
    }
    state.albumView = {
        cacheArr: [],
        clusterAlbumsArr: [],
        currentClusterName: "",
        currentAlphabetIndex: 0,
        skip: 0,
        showViewLess: false,
    }
}

export default (data={}) => {
    const initialState = {
            onwedAlbums:{
                data: data.onwedAlbums || {},
                currentRequestId: "",
                sortOrder:"",
                sortCriteria:"",
                loading: "",
                error: "",
                pageNo: 0
            },
            captionSortAlbums: {
                data: data.captionSortAlbums || {},
                individualAlphabetCache: [],
                currentRequestId: "",
                sortOrder:"",
                sortCriteria: "caption",
                loading: "",
                error: "",
            },
            mySharedAlbums:{
                data: data.mySharedAlbums || {},
                error: ""
            },

            myFriendsAlbums: {
                data: data.myFriendsAlbums || {},
                error: ""
            },

            allAlbumPicInfo: {
                selectedAlbums: {
                    data: data.selectedAlbums || {},
                    error: "",
                },
                unSelectedAlbums: {
                    currentUnselectedAlbumPicInfo: []
                }
            },

            deletedAlbumsArr:[],

            albumView: {
                cacheArr: [],
                clusterAlbumsArr: [],
                currentClusterName: "",
                currentAlphabetIndex: 0,
                skip: 0,
                showViewLess: false,
            },
        };

    return initialState;
}